<template>
    <section class="section section-shaped section-lg my-0">
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5"
                        class="border-0 card">
                        <template>
                            <form ref="form">
                                <div class="mb-5">
                                    <div class="row">
                                        <template v-if="isBusy">
                                            <strong>Verifkasi akun sedang berlangsung, harap tunggu ...</strong>
                                        </template>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>

import axios from "axios";
import Swal from "sweetalert2";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import qs from "qs";

export default {
    components: {
        PulseLoader,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            form: {
                token: null
            },
            isBusy: true,
        };
    },
    mounted(){
        this.verification()
    },
    methods: {
        async verification() {
            const me = this;
            try {
                this.isBusy = true;
                me.form.token = me.$route.params.token
                let { status } = await axios.post(
                    "/api/v1/user/activation",
                    qs.stringify(me.form)
                );

                if (status >= 200 && status <= 202) {
                    Swal.fire({
                        title: "",
                        text: "Verifikasi Email Berhasil. Silahkan masuk ke Akun Anda",
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Tutup!",
                    }).then(() => {
                        me.$router.push("/landing");
                    });
                }
            } catch (error) {
                // console.log(error);
            } finally {
                this.isBusy = false;
            }

        },
    }
};
</script>
<style lang="scss" scoped>
.card {
    border-color: #425d94 !important;
    margin-bottom: 20px;
    border: 1px solid !important;
}
</style>
